<template lang='html'>
  <section class='dashboard'>
    <!-- Page Title Header Starts-->
    <div class="proBanner">
    </div>
    <div class='row page-title-header'>
      <div class='col-12'>
        <div class='page-header'>
          <h4 class='page-title'>Sint-Truiden</h4>
        </div>
      </div>
    </div>
    <!-- Page Title Header Ends-->
    <div class='row'>
      <div class='col-md-8 grid-margin stretch-card'>
        <div class='card'>
          <div class='card-body'>
            <div class="message">
              <div>
                <h4 class="card-4 text-center">Nieuwe campagne</h4>
                <div>
                  <div style="height:25px"></div>
                  <div>
                    <div class="d-flex justify-content-center">
                      <h5 class="card-5 text-center" style="margin-bottom:40px;">Stap 1: selecteer aanwezige collega's</h5>
                    </div>
                    <div class="d-flex justify-content-center">
                      <b-table striped hover :items="items" :fields="fields" style="max-width:65%;">
                        <template v-slot:cell(isActive)="row">
                          <b-form-checkbox v-model="row.isActive" @change="colleagueActiveChanged($event)">
                          </b-form-checkbox>
                        </template>
                      </b-table>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
                <div style="height:25px;"></div>
                <div :hidden="!isStep2Visible">
                  <div class="d-flex justify-content-center">
                    <h5 class="card-5" style="margin-bottom:40px">Stap 2: Selecteer het CSV bestand</h5>
                  </div>
                  <div class="d-flex justify-content-center">
                    <p id="errorMessage" style="color: red; font-weight: bold; display: none"></p>
                    <input class="btn-fw btn-rounded" id="upload" type="file"/>
                  </div>
                  <div>
                    <div class="d-flex justify-content-center" style="margin-top:20px">
                      <span class="text-success text-center" id="successfulImports"></span>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex justify-content-center">
                      <span class="text-danger text-center" id="unsuccessfulImports"></span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center" style="margin-top:25px">
                    <b-button :disabled="!validCampaign" variant="primary" class="btn-fw btn-rounded" v-on:click="processCSV()">Importeer contacten</b-button>
                  </div>
                </div>

              </div>
              <hr style="width:100%; margin-top:20px; margin-bottom: 20px;">
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <div class='col-md-4 grid-margin stretch-card'>
        <div class='card'>
          <div class='card-body'>
            <div class="message">
              <div style="width:100%">
                <h4 class="card-4 text-center">Campaign status</h4>
              </div>
              <div class="d-flex justify-content-center" style="margin-top:100px">
                <h2 class="text-center" v-bind:class="getActiveInactiveClass(this.isCampaignActive)">{{ resumePauseButtonText }} </h2>
<!--                <img src="./src/assets/icons/noun_play_3535575.png" alt="">-->
              </div>
              <div class="d-flex justify-content-center" style="margin-top:25px;">
                <b-button :disabled="!validCampaign" class="btn-rounded" style="background-color: white; text-align: center" @click="resumePauseButtonClick($event)">
                  <img v-if="isCampaignActive" style="height:120px" class="ml-0" src="../assets/icons/noun_play_3535575.png">
                  <img v-if="!isCampaignActive" style="height:120px" class="ml-0" src="../assets/icons/noun_pause_3535549.png">
                </b-button>
                <div v-bind:style="{ backgroundImage: 'url(./src/assets/icons/noun_play_3535575.png)'}"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="row">
      <div class='col-md-12 grid-margin stretch-card'>
        <div class='card'>
          <div class='card-body'>
            <div class="message">
              <div id="step2">
                <div>
                  <div class="d-flex justify-content-center">
                    <h5 class="text-center" style="margin-bottom:40px;">Stap 3: valideer gegevens</h5>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-button variant="primary" class="btn-fw btn-rounded" :disabled="!startCallButtonVisible" v-on:click="initiate_calls()">Start calls</b-button>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-table id="contactsTable" ref="contactTable" :tbody-tr-class="rowClass" striped hover :items="contacts" :fields="contactFields" style="max-width:64%;" dataTable>
                      <template v-slot:cell(index)="data">
                        <div v-if="data.item.status === 'done'">
                          <span>{{data.index + 1}}</span>
                        </div>
                        <div v-else>
                          <b>{{data.index + 1}} </b>
                        </div>

                      </template>
                      <template v-slot:cell(firstname)="data">
                        <div v-if="data.item.status === 'done'">
                          <span>{{data.item.firstname}}</span>
                        </div>
                        <div v-else>
                          <b>{{data.item.firstname}} </b>
                        </div>
                      </template>

                      <template v-slot:cell(phone)="data">
                        <div v-if="data.item.status === 'done'">
                          <span>{{data.item.phone}}</span>
                        </div>
                        <div v-else>
                          <b>{{data.item.phone}} </b>
                        </div>
                      </template>

                      <template v-slot:cell(status)="data">
                        <div v-if="data.item.status === 'done'">
                          <img style="height:30px;" src="../assets/icons/done.png" alt="">
                        </div>

                        <div v-else>
                          <div v-if="data.item.status === 'todo'">
                            <img style="height:30px;" src="../assets/icons/todo.png" alt="">
                          </div>
                          <div v-else>
                            <div v-if="data.item.status === 'in_progress'">
                              <img style="height:30px;" src="../assets/icons/todo.png" alt="">
                            </div>
                            <div v-else>
                              <img style="height:30px;" src="../assets/icons/error.png" alt="">
                            </div>
                          </div>
                        </div>

                      </template>

                      <template v-slot:cell(valid)="data">
                        <div v-if="data.item.valid === 'true'">
                          <img style="height:30px;" src="../assets/icons/success.png" alt="">
                        </div>
                        <div v-else>
                          <img style="height:30px;" src="../assets/icons/error.png" alt="">
                        </div>
                      </template>
                    </b-table>
                  </div>
<!--                  <div class="d-flex justify-content-center">-->
<!--                    -->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang='js'>
import statsLineGraph1 from '../components/charts/dashboard_1/stats-line-graph-1'
import statsLineGraph2 from '../components/charts/dashboard_1/stats-line-graph-2'
import statsLineGraph3 from '../components/charts/dashboard_1/stats-line-graph-3'
import statsLineGraph4 from '../components/charts/dashboard_1/stats-line-graph-4'
import salesStatisticsOverview from '../components/charts/dashboard_1/sales-statistics-overview'
import netProfit from '../components/charts/dashboard_1/net-Profit'
import totalRevenue from '../components/charts/dashboard_1/total-revenue'
import marketOverviewChart from '../components/charts/dashboard_1/market-overview-chart'
import totalTransaction from '../components/charts/dashboard_1/total-transaction'
import realtimeStatistics from '../components/charts/dashboard_1/realtime-statistics'
import usersDoughnutChart from '../components/charts/dashboard_1/usersDoughnutChart'
import { mapGetters } from 'vuex'
// import store from '../store'
import JQuery from 'jquery'
import axios from 'axios'
let server = require('../server')
let $ = JQuery
export default {
  name: 'dashboard',
  components: {
    statsLineGraph1,
    statsLineGraph2,
    statsLineGraph3,
    statsLineGraph4,
    salesStatisticsOverview,
    netProfit,
    totalRevenue,
    marketOverviewChart,
    totalTransaction,
    realtimeStatistics,
    usersDoughnutChart
  },
  data () {
    return {
      fields: [
        {
          key: 'isActive',
          label: 'Is aanwezig?',
          thStyle: {width: '100px'}
        },
        {
          key: 'first_name',
          label: 'Collega'
        }
      ],
      // contactFields: ['index', 'first_name', 'phone', 'status', 'valid'],
      contactFields: [
        {
          key: 'index',
          label: 'ID'
        },
        {
          key: 'firstname',
          label: 'Voornaam'
        },
        {
          key: 'phone',
          label: 'Telefoonnummer'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'valid',
          label: 'Is geldig'
        }
      ],
      items: [
        { isActive: true, first_name: 'Mathias' },
        { isActive: false, first_name: 'Riyan' },
        { isActive: true, first_name: 'Gerrit' }
      ],
      resumePauseButtonText: 'INACTIEF',
      isCampaignActive: false,
      totalColleaguesAvailable: 0,
      validCampaign: false,
      isStep2Visible: false,
      startCallButtonVisible: false,
      contacts: [],
      numberOfImportedContacts: 0,
      numberOfInvalidContacts: 0
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      role: 'role',
      office: 'office'
    })
  },
  // created () {
  //   this.interval = setInterval(this.processCSV, 5000)
  // },
  methods: {
    fillTable (data) {
      console.log('Filling data!')
      this.contacts = data
    },
    rowClass (item, type) {
      if (item && type === 'row') {
        if (item.status === 'done') {
          return 'table-secondary'
        } else {
          return 'table-active'
        }
      } else {
        return null
      }
    },
    toggleProBanner: function () {
      $('body').toggleClass('pro-banner-collapse')
    },
    resumePauseButtonClick (e) {
      this.isCampaignActive = !this.isCampaignActive
      if (this.isCampaignActive) {
        console.log('TODO => RESUME CAMPAIGN')
        this.resumePauseButtonText = 'ACTIEF'
      } else {
        this.resumePauseButtonText = 'INACTIEF'
        console.log('TODO => PAUSE CAMPAIGN')
      }
    },
    getActiveInactiveClass () {
      return {
        'text-success': this.isCampaignActive,
        'text-danger': !this.isCampaignActive
      }
    },
    colleagueActiveChanged (e) {
      if (e === true) {
        this.totalColleaguesAvailable += 1
        this.isStep2Visible = true
        this.startCallButtonVisible = true
      } else {
        this.totalColleaguesAvailable -= 1
        this.startCallButtonVisible = false
      }

      this.validCampaign = this.totalColleaguesAvailable > 0

      console.log("Total colleagues selected: '" + this.totalColleaguesAvailable.toString() + "'")
    },
    async processCSV () {
      let error = document.getElementById('errorMessage')
      error.style.display = 'flex'
      error.innerText = ''
      let file = document.getElementById('upload').files[0]
      let formData = new FormData()
      formData.append('csvfile', file)
      let self = this

      try {
        // const fetchResponse = await fetch('https://79znwy2ew9.execute-api.eu-central-1.amazonaws.com/prod/upload_csv', settings)
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/upload_csv',
          data: formData
        })
          .then(function (response) {
            let data = response.data
            console.log('axios data =')
            console.log(data)
            self.contacts = data.contacts
            self.numberOfImportedContacts = data.imported_contacts
            self.numberOfInvalidContacts = data.invalid_contacts
            let successfulImports = document.getElementById('successfulImports')
            let unsuccessfulImports = document.getElementById('unsuccessfulImports')

            if (self.numberOfImportedContacts !== 0) {
              if (self.numberOfImportedContacts === 1) {
                successfulImports.innerText = 'Successfully imported 1 contact.'
              } else {
                successfulImports.innerText = 'Successfully imported ' + self.numberOfImportedContacts.toString() + ' contacts.'
              }
            }
            if (self.numberOfInvalidContacts !== 0) {
              if (self.numberOfInvalidContacts === 1) {
                unsuccessfulImports.innerText = 'Unable to import ' + self.numberOfInvalidContacts.toString() + ' contact due to an invalid phone number.'
              } else {
                unsuccessfulImports.innerText = 'Unable to import ' + self.numberOfInvalidContacts.toString() + ' contacts due to an invalid phone number.'
              }
            }
            self.startCallButtonVisible = true

            if (data === 'No file' || data === false) {
              console.log('No file detected!')
              let error = document.getElementById('errorMessage')
              error.style.display = 'flex'
              error.innerText = 'Geen bestand geselecteerd.'
              return false
            }
            if (data[0] === 'NOTCSV') {
              console.log('Please choose a CSV file. You tried processing a .' + data[1].toString() + ' file.')
              let error = document.getElementById('errorMessage')
              error.style.display = 'flex'
              error.innerText = 'Je probeerde een ' + this.contacts[1].toString() + ' bestand up te loaden. Selecteer aub een CSV bestand.'
              return false
            }
            if (data === 'INVALID HEADERS') {
              let error = document.getElementById('errorMessage')
              error.style.display = 'flex'
              error.innerText = 'Geen "Voornaam", "Naam", "Stad" of "Telefoonnummer" header gevonden in het excel of CSV bestand.'
              return false
            }
            console.log('Just set contacts!')
            self.$forceUpdate()
            console.log('refreshed table!')
            // self.fillTable(data)
            let button = document.getElementById('step2')
            button.style.display = 'flex'
            let table = document.getElementById('mytable')
            table.style.display = 'flex'
          })
        return this.contacts
      } catch (e) {
        return e
      }
    },
    initiate_calls () {
      console.log('Initiating calls...')
    }
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue